import { useCallback, useEffect, useState } from "react";
import _isEmpty from "lodash/isEmpty";
import { GET_TOURNAMENT_DETAILS } from "../appConstants/APIEndpoint";
import { requestApiPost } from ".";
import { getTournamentCurrentStatus } from "../utils/helpers/TournamentNXUtils";
import {
  getNXTournamentInfo,
  setNXTournamentInfo,
} from "../pages/TournamentDetails/helper";
import { TournamentDetailsConfig } from "../interfaces/TournamentDetailsConfig";
import { useTokenStore } from "../storage/tokenState";
import { initializeGameplaySocket } from "../classes/socket/gameplay";
import { JOIN_TOURNAMENT_TABLE } from "../utils/helpers/constants";

interface IUseNxDetails {
  gameName: string;
  ltid: number;
}

const useTournamentDetails = ({ gameName, ltid }: IUseNxDetails) => {
  const { token: userToken } = useTokenStore();
  const { accessToken } = userToken;

  const [loading, setLoading] = useState<boolean>(false);
  const [tournamentStatus, setTournamentStatus] = useState<string>("");

  const fetchTournamentInfo = useCallback(
    async (showLoader: any) => {
      if (showLoader) {
        setLoading(true);
      }
      const body = {
        gameName,
        ltid,
        screenDetails: true, // for ludo NX
      };
      const config = { headers: { Authorization: accessToken } };
      try {
        const res = await requestApiPost<TournamentDetailsConfig>(
          GET_TOURNAMENT_DETAILS,
          body,
          config
        );
        const response = res?.response;
        if (response?.success && !_isEmpty(response?.tournament)) {
          setNXTournamentInfo(response?.tournament);
          let gameplayServer = response?.tournament?.gameplayServer;
          if (!_isEmpty(gameplayServer)) {
            // console.log(" gameplayServergameplayServer", gameplayServer)
            await initializeGameplaySocket(gameplayServer, {
              en: JOIN_TOURNAMENT_TABLE,
              data: { ltid },
            });
          }
          const newTournamentStatus = getTournamentCurrentStatus(
            response?.tournament
          );
          setTournamentStatus(newTournamentStatus);
        }
      } catch (error) {
        // setErrorMessage(error?.message || 'No data available')
        // logger(TAG_NAMES.DEPOSIT, 'fetchTDSCertificates', {
        //   isAddEvent: true,
        //   isLogToFile: false,
        //   error
        // })
      } finally {
        if (showLoader) {
          setLoading(false);
        }
      }
    },
    [accessToken, gameName, ltid]
  );

  const setTournamentCurrentStatus = useCallback(async () => {
    await fetchTournamentInfo(false);
    const tournamentInfo = getNXTournamentInfo();
    const newTournamentStatus = getTournamentCurrentStatus(tournamentInfo);
    setTournamentStatus(newTournamentStatus);
  }, [fetchTournamentInfo]);

  // useEffect(() => {
  //   fetchTournamentInfo(true);

  //   //POLLING
  //   const pollingInterval = setInterval(() => {
  //     fetchTournamentInfo(false);
  //   }, POLLING_INTERVAL_TIME);

  //   return () => {
  //     clearInterval(pollingInterval);
  //   };
  // }, []);

  return {
    tournamentStatus,
    loading,
    gameName,
    fetchTournamentInfo,
    setTournamentCurrentStatus,
  };
};

export default useTournamentDetails;
